'use client'

import { usePathname } from 'next/navigation'
import { PropsWithChildren } from 'react'

export default function FooterVisibility({ children }: PropsWithChildren) {
  const pathname = usePathname()

  if (pathname.includes('/html5')) return null

  return <>{children}</>
}